/*
 * Filename: panel.js
 * Responsible all cmponent with headding
 * and child components
 */

import React from 'react';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import classNames from 'classnames';
import Divider from 'material-ui/Divider';
import { delay } from 'lodash';

// Right icon option component

const BottonPanelIconOption = (props) => (
  <IconMenu
    {...props}
    iconButtonElement={
    <IconButton><i className="material-icons">more_vert</i></IconButton>
    }
    targetOrigin={{horizontal: 'right', vertical: 'top'}}
    anchorOrigin={{horizontal: 'right', vertical: 'top'}}
  >
   <MenuItem primaryText="List 1" />
    <MenuItem primaryText="List 2" />
    <MenuItem primaryText="List 3" />
    <MenuItem primaryText="List 4" />
  </IconMenu>
);
let childDownloadData = null;
const Panel = (props) => {
  const panelClass = classNames ({
    'readmin-panel' : true,
    'righticonmenu': true,
    'body-text-center': props.center
  });

  const SetdownloadData = (downloadCSVORXLSDocument)=>{
 
  
    childDownloadData = downloadCSVORXLSDocument

    
 }

 const CalldownloadData = ()=>{

    if(childDownloadData){
      childDownloadData();
    }
}


  return (
    <div className={panelClass}>
      <div className="panel-heading">
        <h5>{props.title}</h5>
        { props.righticon ? <BottonPanelIconOption /> : null}

        <div>
          <IconMenu
            anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
            iconButtonElement={
              <IconButton>
                <i className="material-icons">file_download</i>
              </IconButton>
            }
          >
            {
              <span>
                <MenuItem
                  onClick={() =>{
                        props.extensionGetter("XLS")
                        delay(()=>CalldownloadData(),1500)
                  }}
                  primaryText="Excel"
                />
                <Divider />
                <MenuItem
                 onClick={async() =>{
                   props.extensionGetter("CSV")
                   delay(()=>CalldownloadData(),1500)
             }}
                  primaryText="CSV(Comma delimited)"
                />
              </span>
            }
          </IconMenu>
        </div>
      </div>
      <div className="panel-body">
        {React.cloneElement(props.children, {downloadData:SetdownloadData})}
      </div>
    </div>
  );
}

export default Panel;



// WEBPACK FOOTER //
// ./src/adminCharts/BottonPanelToolTip.js